import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const PlusCircle = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("polygon", { points: "13,6 11,6 11,11 6,11 6,13 11,13 11,18 13,18 13,13 18,13 18,11 13,11 \t" }),
    React.createElement("path", { d: "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z M12,21c-5,0-9-4-9-9c0-5,4-9,9-9c5,0,9,4,9,9\n\t\t    C21,17,17,21,12,21z" })), 'PlusCircle');
export default PlusCircle;
